import { StringNameAvatar } from '@/components/lemmala-design-system/avatar'
import type { DropdownSelectItem } from '@/components/lemmala-design-system/dropdown/dropdown-select.types'

import { personFilterLabels } from './labels'

export type PersonOption = {
  id: string
  displayName: string
}

export const getPersonDisplayName = (name?: string, email?: string, fallback = 'Unknown User') =>
  name || email || fallback

export const getCurrentUserFilterId = (
  allUsers: Array<{ id: string; name?: string; email?: string }>,
  currentUser?: { userId?: string; name?: string; email?: string } | null,
) => {
  if (!currentUser?.userId) return undefined

  const matchedUser = allUsers.find((user) => user.id === currentUser.userId)
  if (matchedUser) {
    return getPersonDisplayName(matchedUser.name, matchedUser.email)
  }
  return currentUser.name || currentUser.email || undefined
}

const sortPersonOptions = (people: PersonOption[], currentUserId?: string): PersonOption[] =>
  [...people].sort((a, b) => {
    if (currentUserId) {
      if (a.id === currentUserId) return -1
      if (b.id === currentUserId) return 1
    }
    return a.displayName.localeCompare(b.displayName)
  })

export const buildPersonDropdownItems = (
  people: PersonOption[],
  currentUserId?: string,
): DropdownSelectItem[] =>
  sortPersonOptions(people, currentUserId).map((person) => ({
    id: person.id,
    label: person.displayName,
    labelSuffix: person.id === currentUserId ? personFilterLabels.youSuffix : undefined,
    icon: <StringNameAvatar name={person.displayName} size='small' />,
  }))
